// 対戦の相手のブロックと通報。
// - ブロック：users/{自分}/blocks/{相手} に置く。相手探しのとき待合室に渡し、同じ部屋にしない。
// - 通報：reports に1件書く（書くだけ。読めるのは管理の側だけ。同じ相手・同じゲームは1件まで）。理由は決まった物から選ぶ（自由な文字は書けない）。
import { collection, doc, getDocs, limit, query, serverTimestamp, setDoc } from "firebase/firestore";
import { auth, db } from "./firebase";

export const REPORT_REASONS = ["cheat", "grief", "afk", "other"] as const;
export type ReportReason = (typeof REPORT_REASONS)[number];

const MAX_BLOCKS = 200;

export async function listBlocks(): Promise<string[]> {
  const uid = auth.currentUser?.uid;
  if (!uid) return [];
  const snap = await getDocs(query(collection(db, "users", uid, "blocks"), limit(MAX_BLOCKS)));
  return snap.docs.map((d) => d.id);
}

export async function block(other: string): Promise<void> {
  const uid = auth.currentUser?.uid;
  if (!uid || other === uid) return;
  await setDoc(doc(db, "users", uid, "blocks", other), { at: serverTimestamp() });
}

export async function report(other: string, gameId: string, reason: ReportReason): Promise<void> {
  const uid = auth.currentUser?.uid;
  if (!uid || other === uid) return;
  try {
    // 同じ相手・同じゲームの通報は1件まで（ルールで ID を固定している）。2回目は受け付け済みとして扱う
    await setDoc(doc(db, "reports", `${uid}_${other}_${gameId}`), { reporter: uid, reported: other, gameId, reason, at: serverTimestamp() });
  } catch (e) {
    if ((e as { code?: string }).code !== "permission-denied") throw e;
  }
}
